<template>
  <div>

      <v-btn :loading="loadingCopy" :color="color" text @click="showDialog()">
        {{ label }}
      </v-btn>

      <v-dialog v-model="dialog" max-width="700px" height="90%" width="90%" scrollable>
        <v-card :loading="loadingCopy">

          <v-card-title>
            <span class="headline">Copiar Tarjas</span>
          </v-card-title>



          <v-container class="py-0">
            <v-row no-gutters>
              <v-col :cols="12" :sm="5">
                <v-menu
                ref="menu"
                v-model="menuFO"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                  :loading="loadingTarjas"
                  :value="formatFechaOrigen"
                  hide-details
                  label="F. Origen"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                v-model="fechaOrigen"
                no-title
                scrollable
            :first-day-of-week="1"
            locale="es-cl"
                @change="menuFO = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :xs="2" class="d-none d-sm-flex justify-center align-middle">
              <v-icon class>chevron_right</v-icon>
            </v-col>
            <v-col :cols="12" :sm="5">
              <v-menu
              ref="menu"
              v-model="menuFD"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                :value="formatFechaDestino"
                hide-details
                label="F. Destino"
                prepend-icon="event"
                readonly
                v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
              v-model="fechaDestino"
              no-title
              @change="menuFD = false"
              scrollable
              :first-day-of-week="1"
              locale="es-cl"
              ></v-date-picker>
            </v-menu>
          </v-col>

        </v-row>
      </v-container>






          <v-card-text class="pt-0 grey lighten-5" >
            <v-container grid-list-md>
              <v-row no-gutters>
                <v-col :cols="12">
                  <v-row>
                    <v-col :cols="12" class="pa-0">
                      <v-subheader>
                        <v-checkbox
                          small
                          class="mr-4"
                          :value="selectedAll"
                          color="secondary"
                          @change="selectAll()"
                        ></v-checkbox>
                        Copiar tarjas de:</v-subheader>
                      <v-list dense color="transparent">
                        <v-list-item-group v-model="personasSelected" multiple>
                          <template v-for="(item, i) in personasOptions">
                            <v-list-item :key="`item-${i}`" active-class="secondary--text" :value="item.id">
                              <template v-slot:default="{ active, toggle }">
                                <v-list-item-action>
                                  <v-checkbox
                                    :input-value="active"
                                    :true-value="item"
                                    color="secondary"
                                    @click="toggle"
                                  ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                  <v-list-item-title
                                    v-text="item.nombre"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                      <v-alert type="info" text :value="tarjas.length == 0 && !loadingTarjas" icon="find_in_page">
                        Fecha sin tarjas
                      </v-alert>
                    </v-col>
                    <!--
                    <v-col :cols="12" :sm="6">
                      <v-subheader>Copiar tarjas con:</v-subheader>
                      <v-list dense>
                          <template v-for="(item, i) in items">

                            <v-list-item
                              :key="`item-${i}`"
                              active-class="accent--text text--accent-4"
                            >
                                <v-list-item-action>
                                  <v-checkbox
                                  v-model="item.selected"
                                    color="accent accent-4"
                                  ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                  <v-list-item-title
                                    v-text="item.label"
                                  ></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                          </template>
                      </v-list>
                    </v-col>
                  -->
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>




          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn color="primary darken-1" @click="ok()">
              Copiar
            </v-btn>
          </v-card-actions>



        </v-card>
      </v-dialog>

  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import tarjaModel from "@/models/tarjaModel";
import Repository from "@/models/repoIrricrops";


export default {
  name: "copiarTarjas",
  props: {
    color        : {},
    trabajadores : {},
    disabled     : {default: false},
    label        : {},
    fechaDestino : {default: moment(new Date()).format("YYYY-MM-DD")}
  },
  data: () => ({
    fechaOrigen: moment(new Date()).subtract(1, "day").format("YYYY-MM-DD"),
    //fechaDestino     : moment(new Date()).format("YYYY-MM-DD"),
    dialog           : false,
    menuFO           : false,
    menuFD           : false,
    loadingTarjas    : false,
    loadingCopy      : false,
    personasSelected : [],
    personasOptions  : [],
    tarjas           : [],
    itemsSelected    : [],
    //selectedAll      : true,
    items: [
      {label: "Labor",          attr:"sub_labor_id",    selected:true},
      //{label: "Asistencia",attr:"asistencia", selected:false},
      {label: "Centros costo",  attr:"centro_costo_id", selected:true},
      {label: "Rendimiento",    attr:"rendimiento",     selected:false},
      {label: "Valor Unidad",   attr:"valor_unidad",    selected:true},
      {label: "Horas Extras",   attr:"horas_extras",    selected:false},
      {label: "Bonos",          attr:"bonos",           selected:false}
    ]
  }),
  watch:{
    dialog(){
      //this.personasSelected = this.personas;
      if(this.dialog){
        this.getTarjas();
        this.fechaOrigen = moment(this.fechaDestino).subtract(1, "day").format("YYYY-MM-DD");
      }
    },
    fechaOrigen(){
      this.getTarjas();
    },
    empresaSelected(){
      if(this.empresaSelected){
        this.getTarjas();
      }
    }
  },
  computed: {
    formatFechaOrigen() {
      return moment(this.fechaOrigen).format("DD [de] MMM");
    },
    formatFechaDestino() {
      return moment(this.fechaDestino).format("DD [de] MMM");
    },
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    selectedAll(){
      return this.personasSelected.length == this.personasOptions.length;
    }
  },
  methods: {
    getTarjas() {
      var self = this;
      this.loadingTarjas = true;
      var p = tarjaModel.all({params:{
        empresa_id : this.empresaSelected.id,
        fecha_inicio : this.fechaOrigen,
      }}).then(res => {
        this.tarjas = res.data.data.tarjas;
        this.personasOptions = _.values(_.mapValues(
          _.groupBy(self.tarjas, tarja => {
            return tarja.trabajador_id
          }), (value, trabajador_id) => {
            return _.find(self.trabajadores, {id: parseInt(trabajador_id)})
        }));
        this.selectAll();
        this.loadingTarjas = false;
      })
      return p;
    },
    copyTarjas(){
      this.loadingCopy = true;
      var tarjas = _(this.tarjas).filter( tarja => {
        return this.personasSelected.indexOf(tarja.trabajador_id) > -1;
      }).map("id").value();

      return Repository.post("copiar", {
          tarjas_ids: tarjas,
          fecha_destino : this.fechaDestino
      }).then(res => {
          this.$store.commit("showSnackBar", "Copiados Satisfactoriamente")
       });

    },
    /*
    copyTarjas_dep() {
      this.loadingCopy = true;
      var tarjas = _.filter(this.tarjas, tarja => {
        return this.personasSelected.indexOf(tarja.trabajador_id) > -1;
      });

      var promises = [];
      _.forEach(tarjas, tarja => {
        var t = _.clone(tarja);
        t.fecha = this.fechaDestino;
        if(t.asistencia_id == null){
          delete t.asistencia_id;
        }
        if(t.valor_hora_extra== null){
          delete t.valor_hora_extra;
        }
        if(t.valor_dia== null){
          delete t.valor_dia;
        }
          promises.push(tarjaModel.add(t));
      });

      return axios.all(promises).then(res => {
          this.$store.commit("showSnackBar", "Copiados Satisfactoriamente")
       });
    },
    */
    showDialog(){
      /*this.getTarjas().then(res => {
        this.dialog = true;
      });*/
      this.dialog = true;
    },
    selectAll(){
      if(this.selectedAll){
        this.personasSelected = [];
      }else{
        this.personasSelected = _.map(this.personasOptions, "id");
      }
    },
    cancel() {
      this.dialog = false;
    },
    ok() {
      this.copyTarjas().then(res => {
        this.loadingCopy = false;
        this.dialog = false;
        this.$emit('onCopy');
      });
    }
  }
};
</script>
